module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_j_piebald.b982dac1.png";